import React from 'react'

const Vision = () => {
  return (
    <div>
        <h2 className='text-center'>Visión:</h2>
        <p className='text-center'>Ser reconocido como empresa líder en proporcionar soluciones innovadoras de alta tecnología y alta calidad a clientes en Latino América.</p>
    </div>
  )
}

export default Vision